const usParser = require('ua-parser-js')

// get os and browser info from userAgent
export const getUAInfo = (userAgent: string) => {
  const uaInfo = new usParser(userAgent)
  console.log('*******device full info******', uaInfo.getResult())
  return uaInfo.getResult()
}

// get system type from userAgent
export const clientType = () => {
  let client = ''
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    client = 'iOS'
  } else if (/(Android)/i.test(navigator.userAgent)) {
    client = 'Android'
  } else {
    client = 'PC'
  }
  return client
}
